import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	Typography
} from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { SRAccount, ChargebeePlans, ChargebeePlansV2 } from '@api/v1';
import { patchAccountPlan } from './actions';
import { useDispatch } from 'react-redux';

export const ChangePlanButton = ({ account }: { account: SRAccount }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();

	const selectablePlans = [ChargebeePlans.RELAY_JANITOR_FREE];
	const [selectedPlan, setSelectedPlan] = useState<ChargebeePlansV2 | ChargebeePlans>(
		selectablePlans[0]
	);
	const [confirmOpen, setConfirmOpen] = useState(false);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const handlePlanChange = (event) => setSelectedPlan(event.target.value);

	const handleApplyPlan = () => {
		setOpen(false);
		setConfirmOpen(true);
	};

	const handleConfirmYes = () => {
		dispatch(patchAccountPlan(account.id, { plan: selectedPlan }));
		setConfirmOpen(false);
	};

	const handleConfirmNo = () => {
		setConfirmOpen(false);
		setOpen(true);
	};

	return (
		<>
			<Button variant="outlined" color="primary" onClick={handleOpen}>
				{t('sysadmin:account_change_plan')}
			</Button>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>{t('sysadmin:account_change_plan')}</DialogTitle>
				<DialogContent>
					<Typography>{t('sysadmin:account_select_plan')}</Typography>
					<TextField
						select
						label={t('sysadmin:account_plan')}
						value={selectedPlan}
						onChange={handlePlanChange}
						fullWidth
						margin="normal"
						SelectProps={{ native: true }}
					>
						{selectablePlans.map((plan) => (
							<option key={plan} value={plan}>
								{plan}
							</option>
						))}
					</TextField>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						{t('sysadmin:account_select_plan_cancel')}
					</Button>
					<Button onClick={handleApplyPlan} color="primary" disabled={selectedPlan === undefined}>
						{t('sysadmin:account_select_plan_apply')}
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={confirmOpen}
				onClose={handleConfirmNo}
				PaperProps={{
					sx: {
						width: 'auto',
						m: 'auto'
					}
				}}
			>
				<DialogTitle>{t('sysadmin:account_confirm_plan_change_title')}</DialogTitle>
				<DialogContent>
					<Typography>
						<Trans
							i18nKey="sysadmin:account_confirm_plan_change_text"
							values={{ currentPlan: account.plan, selectedPlan }}
							components={{ bold: <strong /> }}
						/>
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleConfirmNo} color="primary">
						{t('sysadmin:account_select_plan_cancel')}
					</Button>
					<Button onClick={handleConfirmYes} color="primary">
						{t('sysadmin:account_select_plan_apply')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
